export const CONST = {
  INITIAL_TRANSFORM: 'translate3d(0,0)',
  AUTO: 'auto',
  MAX_HEIGHT_OFFSET: 500,
  MAX_WIDTH_OFFSET: 350,
  UPDATE_OFFSET_Y: '35px',
  UPDATE_OFFSET_X: '0',
  EVENT_RESIZE: 'resize',
  EVENT_SCROLL: 'scroll',
  EVENT_MOUSE_UP: 'mouseup',
  EVENT_MOUSE_MOVE: 'mousemove',
  MAX_DESCRIPTION_LENGTH: 120,
  MIN_DESCRIPTION_LENGTH: 0,
};
